export const department = {
  getDepartments: 'categoryEndpoint/getCategoriesAndSubCategories',
  getCategoryProductsFromAlgolia: 'categoryEndpoint/getProductsFromCategoryAlgolia',
  bestSeller: 'categoryEndpoint/getMostSales',
  getSubcategoriesAndFilters: 'categoryEndpoint/getSubCategoriesAndFilters',
  getProductsFromFilter: 'categoryEndpoint/getProductsFromFilter', 
};
